// extracted by mini-css-extract-plugin
module.exports = {"succeedMessageStyle":"_2CKBPZRQdJbOmi2pZArjd4"};